<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.60026 2.24707C9.91682 2.24707 10.1993 2.44584 10.3063 2.74378L10.6875 3.80547C10.748 3.97242 10.8654 4.1127 11.0191 4.20163L12.1498 4.85441C12.3034 4.943 12.4833 4.97436 12.6578 4.94294L13.7682 4.74261C14.0801 4.68591 14.3939 4.83126 14.5523 5.10576L15.1526 6.14119C15.3114 6.41495 15.2814 6.75894 15.0775 7.00105L14.349 7.86241C14.2342 7.99785 14.1712 8.1696 14.1712 8.34711V9.65265C14.1712 9.83017 14.2342 10.0019 14.349 10.1374L15.0775 10.9987C15.2814 11.2408 15.3114 11.5848 15.1526 11.8586L14.5523 12.894C14.394 13.1682 14.0806 13.3135 13.769 13.2572L12.6585 13.0568C12.4841 13.0254 12.3041 13.0568 12.1506 13.1454L11.0198 13.7981C10.8661 13.8871 10.7487 14.0273 10.6882 14.1943L10.307 15.256C10.2 15.5542 9.9171 15.753 9.60026 15.7527H8.39976C8.08319 15.7527 7.80071 15.5539 7.69371 15.256L7.31255 14.1943C7.25207 14.0276 7.13496 13.8873 6.98167 13.7981L5.85019 13.1454C5.69665 13.0568 5.5167 13.0254 5.34223 13.0568L4.23177 13.2572C3.91994 13.3139 3.60612 13.1685 3.44769 12.894L2.84744 11.8586C2.68859 11.5848 2.71861 11.2408 2.92247 10.9987L3.65103 10.1374C3.76577 10.0019 3.82878 9.83017 3.82885 9.65265V8.34711C3.82878 8.1696 3.76577 7.99785 3.65103 7.86241L2.92998 7.00105C2.72611 6.75894 2.6961 6.41495 2.85495 6.14119L3.4552 5.10576C3.61352 4.83155 3.92694 4.68625 4.23852 4.74261L5.34899 4.94294C5.52345 4.97436 5.7034 4.943 5.85695 4.85441L6.98842 4.20163C7.14172 4.11242 7.25882 3.97221 7.31931 3.80547L7.70046 2.74378C7.80662 2.44816 8.08567 2.24995 8.39976 2.24707H9.60026Z"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="8.99988"
      cy="8.99988"
      r="2.06336"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  props: ["clr"]
};
</script>
